// Single source of truth for the employment-status-driven conditionality
// of the employer-related fields on the Digital Credit App step.
//
// The matrix is locked per Jira NV-570. Per status, each field is either:
//   - `required`: visible and required (existing default behavior)
//   - `optional`: visible but not required (HTML required is dropped, but
//                 stores still keep any existing value)
//   - `disabled`: visible but greyed out and the field's value is cleared
//
// `employment_status` is always required / visible and is not part of the
// matrix

export const EMPLOYMENT_FIELD_RULES = {
    employer_name: {
        required: ["employed", "other"],
        optional: [],
        disabled: ["self", "1099", "military", "student", "retired", "unemployed"],
    },
    job_title: {
        required: ["employed", "self", "other"],
        optional: [],
        disabled: ["1099", "military", "student", "retired", "unemployed"],
    },
    employer_date: {
        required: ["employed", "self", "other", "military", "1099"],
        optional: [],
        disabled: ["student", "retired", "unemployed"],
    },
    employer_phone: {
        required: ["employed", "1099", "military"],
        optional: ["self", "retired", "unemployed", "student", "other"],
        disabled: [],
    },
    yearly_income: {
        required: ["employed", "self", "1099", "military"],
        optional: ["student", "retired", "unemployed", "other"],
        disabled: [],
    },
};

const DISABLED_STATUS = Object.freeze({ disabled: true, required: false });
const REQUIRED_STATUS = Object.freeze({ disabled: false, required: true });
const OPTIONAL_STATUS = Object.freeze({ disabled: false, required: false });

export const getFieldConditionality = (fieldName, employmentStatus) => {
    const rules = EMPLOYMENT_FIELD_RULES[fieldName];
    if (!rules) return REQUIRED_STATUS;

    // When the user has not yet picked a status, preserve the original UX:
    // every employment field is required.
    if (!employmentStatus) return REQUIRED_STATUS;

    if (rules.disabled.includes(employmentStatus)) {
        return DISABLED_STATUS;
    }
    if (rules.required.includes(employmentStatus)) {
        return REQUIRED_STATUS;
    }
    if (rules.optional.includes(employmentStatus)) {
        return OPTIONAL_STATUS;
    }

    // if not mapped assume required
    return REQUIRED_STATUS;
};
